function Khatapage() {
  return <h1>KhataPage</h1>;
}

export default Khatapage;
